<script setup>
  defineProps({
    message: String,
    modelValue: Boolean
  })

  const emits = defineEmits(['close', 'update:modelValue'])

  const close = () => {
    emits('update:modelValue', false)
    emits('close')
  }
</script>

<template>
  <div :class="{ active: modelValue }" class="modal-container">
    <div class="modal-body">
      <!-- 閉じるボタン -->
      <div class="modal-close" @click="close">×</div>
      <!-- モーダル内のコンテンツ -->
      <div class="modal-content">
        <div class="message" v-html="message"></div>
      </div>
    </div>
  </div>
</template>

<style scoped>
  .message {
    font-weight: 700;
    padding: 1rem 3rem 1rem 1rem;
    text-align: center;
  }
</style>
